// Utils
import { ImmutableMap } from '../../../../common/utils/immutableHelper';

export const getBoardHierarchiesMapSelector = (state: ImmutableMap) => state.getIn(['app', 'boardHierarchies']);
